export default __webpack_public_path__ + "static/conflit-actionnaires-litige-avocat-scaled-2a97bf9a88eb7fd87ccbf427c2b3d826.jpg";